import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, applyPreAuthData } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useMusic } from "@/context/MusicContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/home";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

// The managed Google OAuth can't be forced to show the account picker (the gateway builds
// the Google request server-side and drops prompt=select_account), and Google rejects an
// external continue= on its logout URL. The reliable way to switch accounts is to sign the
// user out of Google in a new tab first; the next "Continue with Google" then asks which
// account to use instead of silently reusing the one already signed in.
export function signOutOfGoogle() {
  window.open("https://accounts.google.com/Logout", "_blank", "noopener,noreferrer");
}

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const music = useMusic();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    // Clean the hash so it isn't reprocessed
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        const updated = await applyPreAuthData(data);
        setUser(updated || data);
        try { music && music.resume && music.resume(); } catch (e) { console.debug("music resume skipped:", e); }
        navigate((updated || data).onboarding_completed ? "/home" : "/onboarding");
      } catch {
        toast.error("Google sign-in didn't complete. Please try again.");
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#291B2D] text-[#FCFAF6]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 rounded-full border-2 border-[#C89B55] border-t-transparent animate-spin" />
        <p className="font-display text-xl">Welcoming you in…</p>
      </div>
    </div>
  );
}
